import { render, staticRenderFns } from "./IncomeCorrectTable.vue?vue&type=template&id=627f938d&scoped=true&"
import script from "./IncomeCorrectTable.vue?vue&type=script&lang=ts&"
export * from "./IncomeCorrectTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627f938d",
  null
  
)

export default component.exports